import React from "react";
import PrivacyPolicy from "../../PicesForPages/PrivacyPolicy.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function PrivacyPolicyStatement() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={PrivacyPolicy}
          alt="tlpImage"
          className="background-video PrivacyPolicyImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Privacy Statement</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              <span className="brand_text">VIDHI MORTGAGE LLC</span> has
              developed this Privacy Statement to reflect our strong dedication
              to safeguarding your personal information and maintaining your
              trust.
            </span>

            <span className="purchaseBottomLeftHeader">
              What personal information is being collected?
            </span>
            <span className="purchaseBottomLeftContent">
              Unless this website specifically requests personal details to
              respond to inquiries or to register users for certain services,
              the only information collected during your visit includes: your
              server address; the date and time of access; the pages viewed and
              documents downloaded; the referring website; and the type of
              browser in use. This data is gathered solely for analytical
              purposes to help us enhance the performance and user experience of
              our website.
            </span>

            <span className="purchaseBottomLeftHeader">
              Who is collecting personal information?
            </span>
            <span className="purchaseBottomLeftContent">
              When this website requests your personal information (such as for
              responding to inquiries or registering for services), it is
              collected exclusively by authorized{" "}
              <span className="brand_text">VIDHI MORTGAGE LLC</span> personnel
              responsible for handling such requests and managing registrations.
            </span>

            <span className="purchaseBottomLeftHeader">
              How is personal information used?
            </span>
            <span className="purchaseBottomLeftContent">
              Any personal information collected through this website will be
              used strictly for the purposes clearly stated at the time of
              collection. Your information will never be shared with third
              parties, added to mailing lists, or used for any other purpose
              without your explicit consent.
            </span>

            <span className="purchaseBottomLeftHeader">Cookies</span>
            <span className="purchaseBottomLeftContent">
              Cookies may be classified as either "persistent" or "session"
              cookies. Persistent cookies remain on your device with an
              expiration date and may track your interactions with the website
              upon return visits. Session cookies are temporary, exist only
              during your browsing session, and are automatically deleted once
              you close your browser. Once your session ends, no personally
              identifiable information is retained that could identify you in
              future visits. Access to personal information collected on this
              site Unless legally required,{" "}
              <span className="brand_text">VIDHI MORTGAGE LLC</span> will only
              share your personal information with third parties if you have
              granted permission.
            </span>

            <span className="purchaseBottomLeftHeader">
              Security of personal information collected on this site
            </span>
            <span className="purchaseBottomLeftContent">
              While we strive to implement appropriate security measures, this
              website cannot guarantee the complete security of information
              transmitted over the Internet. Users should understand that data
              transmission online carries inherent risks. Outside Links
            </span>

            <span className="purchaseBottomLeftHeader">Outside Links</span>
            <span className="purchaseBottomLeftContent">
              For your convenience, this website may include links to external
              sites for additional information.{" "}
              <span className="brand_text">VIDHI MORTGAGE LLC</span> does not
              assume responsibility for the content, security, or privacy
              practices of these third-party websites.
            </span>

            <span className="purchaseBottomLeftHeader">Your Rights</span>
            <span className="purchaseBottomLeftContent">
              You have the right to request access to any personal information
              we may hold about you. If you believe that any information we
              maintain is inaccurate or outdated, you may request corrections.
              While accessing your information is free of charge, a reasonable
              processing fee may apply in certain cases.
            </span>

            <span className="purchaseBottomLeftHeader">
              Further Information
            </span>
            <span className="purchaseBottomLeftContent purchaseBottomLeftContent00">
              For more details regarding this Privacy Statement, please contact
              us at{" "}
              <a
                href="mailto: contact@vidhimortgage.com "
                style={{
                  textDecoration: "none",
                  color: "#005bb5",
                  fontWeight: "bold",
                }}
              >
                contact@vidhimortgage.com
              </a>{" "}
              .
            </span>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now!
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyStatement;
